"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.WALLET_SUPPORT = exports.BLOCKCHAIN_SUPPORT = void 0;
var BLOCKCHAIN_SUPPORT = "blockchain_support";
exports.BLOCKCHAIN_SUPPORT = "blockchain_support";
var WALLET_SUPPORT = "wallet_support";
exports.WALLET_SUPPORT = "wallet_support";